import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sinInterceptorGlobal } from 'src/app/shared/utils/error-http-real';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import {
  ParametrosEnum,
  PAGO_MOVIL_MONTO_MAX_DEFAULT,
} from 'src/app/shared/enums/parameters.enum';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  API_URL = environment.apiGatewayURL;
  constructor(
    private http: HttpClient,
    private cognito: CognitoService,
  ) {}

  getParameter(name: string) {
    const serviceURL = `${this.API_URL}parametro/${name}`;
    return firstValueFrom(this.http.get<any>(serviceURL));
  }

  /**
   * Límite máximo (en Bs) permitido para Pago Móvil, configurable desde
   * administración vía el parámetro PAGO_MOVIL_MONTO_MAX. Si el parámetro no
   * existe o es inválido, cae al default (100.000 Bs).
   */
  async getPagoMovilMontoMax(): Promise<number> {
    try {
      const param = await this.getParameter(ParametrosEnum.PAGO_MOVIL_MONTO_MAX);
      const valor = Number(param?.valor);
      return Number.isFinite(valor) && valor > 0
        ? valor
        : PAGO_MOVIL_MONTO_MAX_DEFAULT;
    } catch (error) {
      return PAGO_MOVIL_MONTO_MAX_DEFAULT;
    }
  }
  /**
   * `errorReal`: sin el `ErrorInterceptor` (escape), para que el llamador
   * reciba el status y el mensaje reales (el 403 de los encargados de tasas)
   * y muestre su propio aviso. Por defecto, como siempre.
   */
  saveParameter(descripcion: string, valor: string, opciones: { errorReal?: boolean } = {}) {
    const serviceURL = `${this.API_URL}parametro/${name}`;
    const extra = opciones.errorReal ? { headers: sinInterceptorGlobal(new HttpHeaders()) } : {};
    return firstValueFrom(
      this.http.post<any>(serviceURL, { descripcion, valor }, extra),
    );
  }
}
